import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import VolunteerStart from './VolunteerStart';
import VolunteerDetails from './VolunteerDetails';
import VolunteerSuccess from './VolunteerSuccess';

const Volunteer = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(volunteer|volunteer/start)"
                            name="VolunteerStart"
                            exact
                            component={VolunteerStart}
                        />
                        <Route
                            path="/volunteer/form"
                            name="VolunteerDetails"
                            exact
                            component={VolunteerDetails}
                        />
                        <Route
                            path="/volunteer/success"
                            name="VolunteerSuccess"
                            exact
                            component={VolunteerSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Volunteer;
